import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CognitoService {
  private credentials: any;

  constructor(private http: HttpClient) {
    //
  }

  getIdentity(): Observable<any> {
    if (this.credentials) {
      return Observable.of(this.credentials);
    }

    const subject: Subject<any> = new Subject();
    const mObservable = subject.asObservable();

    this.http.get('/test').subscribe((res: any) => {
      this.credentials = {
        AccessKeyId: res.AccessKeyId,
        SecretKey: res.SecretAccessKey,
        SessionToken: res.SessionToken,
        ClientId: res.ClientId,
      };

      subject.next(this.credentials);
      subject.complete();
    }, (err) => {
      //
    }, () => {
      //
    });

    return mObservable;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cognito.service.ts